import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiDelete, operationsClient } from '@/lib/api';

export function useDeleteLeadStage() {
  const queryClient = useQueryClient();

  return useApiMutation<void, string>({
    mutationFn: (id) => apiDelete<void>(operationsClient, leadEndpoints.stageDetail(id)),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.stages() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Lead stage deleted');
    },
  });
}
